import { post } from "@/utils/utils";
// 导购相关接口
const evaluationManagement = {
  state: {},
  mutations: {
    QUERY_MEMBER_SHOW_SCORE_CONFIG_LIST() {},
    EDIT_MEMBER_SHOW_SCORE_CONFIG() {},
    EDIT_MEMBER_SHOW_SCORE_CONFIG_LIST() {},
    QUERY_MEMBER_SHOW_AUDIT_LIST() {},
    QUERY_MEMBER_SHOW_DETAILS() {},
    EDIT_MEMBER_SHOW_STATE() {},
    QUERY_PRDER_SCORE_PAGE_LIST() {},
    QUERY_ALL_PRDER_SCORE_PAGE_LIST() {},
    QUERY_PAGE_LIST_QUICK_REPLIES(){},
    STORE_QUICK_REPLY_INFO_ADD(){},
    STORE_QUICK_REPLY_INFO_EDIT(){},
    FIND_MEMBER_SHOW_COMMENT(){},
    FIND_EVALUATION_CALLBACK(){},
    QUERY_EVALUATION_SETTINGS(){},
    SAVE_EVALUATION_SETTINGS(){},
    QUERY_ORDER_GUIDE_TEXT(){},
    SAVE_ORDER_GUIDE_TEXT(){},
    STORE_MEMBER_SHOW_REPLY_INFO_ADD(){},
    DEL_QUICK_REPLY_BY_ID(){},
    HIDE_REPLY_BY_SHOW_ID(){},
  },
  actions: {
    hideReplyByShowId({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeMemberShowReplyInfo/hideReplyByShowId`,
        name: "HIDE_REPLY_BY_SHOW_ID",
        params
      });
    },
    delQuickReplyById({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeQuickReplyInfo/delQuickReplyById`,
        name: "DEL_QUICK_REPLY_BY_ID",
        params
      });
    },
    storeMemberShowReplyInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeMemberShowReplyInfo/add`,
        name: "STORE_MEMBER_SHOW_REPLY_INFO_ADD",
        params
      });
    },
    findMemberShowComment({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/memberShow/findMemberShowComment`,
        name: "FIND_MEMBER_SHOW_COMMENT",
        params
      });
    },
    findEvaluationCallback({ commit }, params) {
      return post({
        commit,
        url: `/orderScore/findEvaluationCallback`,
        name: "FIND_EVALUATION_CALLBACK",
        params
      });
    },
    queryEvaluationSettings({ commit }, params) {
      return post({
        commit,
        url: `/evaluationConfig/detail`,
        name: "QUERY_EVALUATION_SETTINGS",
        params
      });
    },
    saveEvaluationSettings({ commit }, params) {
      return post({
        commit,
        url: `/evaluationConfig/save`,
        name: "SAVE_EVALUATION_SETTINGS",
        params
      });
    },
    queryOrderGuideText({ commit }, params) {
      return post({
        commit,
        url: `/sys/text/queryByInfo`,
        name: "QUERY_ORDER_GUIDE_TEXT",
        params
      });
    },
    saveOrderGuideText({ commit }, params) {
      return post({
        commit,
        url: `/sys/text/addOrUpdate`,
        name: "SAVE_ORDER_GUIDE_TEXT",
        params
      });
    },
    storeQuickReplyInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeQuickReplyInfo/edit`,
        name: "STORE_QUICK_REPLY_INFO_EDIT",
        params
      });
    },
    storeQuickReplyInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeQuickReplyInfo/add`,
        name: "STORE_QUICK_REPLY_INFO_ADD",
        params
      });
    },
    queryPageListQuickReplies({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeQuickReplyInfo/queryPageList`,
        name: "QUERY_PAGE_LIST_QUICK_REPLIES",
        params
      });
    },
    queryMemberShowScoreConfigList({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/findMemberShowScoreConfig`,
        name: "QUERY_MEMBER_SHOW_SCORE_CONFIG_LIST",
        params
      });
    },
    editMemberShowConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/editMemberShowConfigById`,
        name: "EDIT_MEMBER_SHOW_SCORE_CONFIG",
        params
      });
    },
    editMemberShowConfigList({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/editMemberShowConfigByList`,
        name: "EDIT_MEMBER_SHOW_SCORE_CONFIG_LIST",
        params
      });
    },
    queryMemberShowAuditList({ commit }, params) {
      return post({
        commit,
        url: `/memberShow/findMemberShowAuditPage`,
        name: "QUERY_MEMBER_SHOW_AUDIT_LIST",
        params
      });
    },
    queryMemberShowDetails({ commit }, params) {
      return post({
        commit,
        url: `/memberShow/findMemberShowDetails`,
        name: "QUERY_MEMBER_SHOW_DETAILS",
        params
      });
    },
    editMemberShowState({ commit }, params) {
      return post({
        commit,
        url: `/memberShow/editMemberShowState`,
        name: "EDIT_MEMBER_SHOW_STATE",
        params
      });
    },
    queryOrderScorePageList({ commit }, params) {
      return post({
        commit,
        url: `orderScore/findOrderScorePage`,
        name: "QUERY_PRDER_SCORE_PAGE_LIST",
        params
      });
    },
    queryAllOrderScorePageList({ commit }, params) {
      return post({
        commit,
        url: `orderScore/findOrderScorePage`,
        name: "QUERY_ALL_PRDER_SCORE_PAGE_LIST",
        params
      });
    }
  }
};

export default evaluationManagement;
